export default () => new Promise((resolve, reject) => {
  if (typeof $().datepicker === 'function') {
    resolve();

    return;
  }

  import(/* webpackChunkName: "datepicker" */ '../datepicker')
    .then(resolve)
    .catch(reject);
});
